import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import showToast from "common/Notification";

import {
  LOGIN_USER,
  LOGOUT_USER,
  SOCIAL_LOGIN,
  VERIFY_OTP,
  POST_LOGIN,
  EMPLOYEE_LOGIN,
  EMP_VERIFY_OTP,
  RESEND_OTP,
  ADMIN_RESEND_OTP,
  SUPER_ADMIN_LOGIN,
  REPORT_LOGIN,
} from "./actionTypes";
import {
  verifyOtpFail,
  apiError,
  loginSuccess,
  postloginFail,
  postloginSuccess,
  verifyOtpSuccess,
  empLoginSuccess,
  empLoginFail,
  resendOtpSuccess,
  resendOtpFail,
  adminResendOtpSuccess,
  adminResendOtpFail,
  superAdminLoginSuccess,
  superAdminLoginFail,
  loginReportsSuccess,
  loginReportsFail,
} from "./actions";

import {
  postFakeLogin,
  onLoggingReports,
  onOtpVerify,
  onAdminLogin,
  onResendOtp,
  PostEmpLoginUser,
  onEmpOtpVerify,
  onAdminResendOtp,
  onLoginSuperAdmin,
} from "helpers/fakebackend_helper";
import { changeLayout, getUserDataSuccess } from "store/actions";
import { layoutTypes } from "constants/layout";
import { responseHandler } from "common/CommanFunction";
import { ROLES } from "common/ComponentAccess";

function* onVerifyOtp({ payload: { data, history, dispatch, onSuccess, onError, header } }) {
  try {
    const _ = yield call(onOtpVerify, data, header);
    if (!_?.status) {
      showToast("warning", "OTP Verification", _.message);
      onError();
    } else if (header && _?.message?.includes("Added")) {
      onSuccess();
    } else if (_.status && _.admin_type == "super admin") {
      const data = {
        ..._,
        uid: _.client_id,
        username: _.client_name,
        role: _.admin_type,
        email: _.client_email,
      };
      localStorage.setItem("authUser", JSON.stringify(data));
      localStorage.setItem("timezone", JSON.stringify(_?.time_zone));
      dispatch(changeLayout(layoutTypes.HORIZONTAL));
      showToast("success", "Authentication", "Successfully login");
      yield put(getUserDataSuccess(data));
      yield put(verifyOtpSuccess(_));
      localStorage.removeItem("loginData");
      onSuccess();
      history.push("/superadmin");
    } else if (_.status && [ROLES.ADMIN, ROLES.MANAGER, ROLES.ACCOUNTANT, "participant"].includes(_.admin_type)) {
      const data = {
        ..._,
        uid: _?.client_id,
        username: _?.client_name,
        role: _?.admin_type,
        email: _?.client_email,
        regis_no: _?.registration_number,
        com_name: _?.company_name,
        verification_email: _?.verification_email ? _?.verification_email : "",
      };
      localStorage.setItem("authUser", JSON.stringify(data));
      localStorage.setItem("timezone", JSON.stringify(_?.time_zone));
      if (_?.profile_pic_path) localStorage.setItem("pro_pic", JSON.stringify(_?.profile_pic_path));
      if (_?.company_logo) localStorage.setItem("company_logo", JSON.stringify(_?.company_logo));
      localStorage.removeItem("loginData");
      dispatch(changeLayout(layoutTypes.VERTICAL));
      yield put(getUserDataSuccess(data));
      yield put(verifyOtpSuccess(_));
      onSuccess();
      showToast("success", "Authentication", "Successfully login");
      // history.push('/dashboard');
    } else {
      onError();
    }
  } catch (error) {
    onError();
    yield put(verifyOtpFail(error));
  }
}

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(postFakeLogin, {
      email: user.email,
      password: user.password,
    });
    localStorage.setItem("authUser", JSON.stringify(response));
    yield put(loginSuccess(response));

    history.push("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* onReportLogin({ payload: { data, onError, onSuccess } }) {
  try {
    const response = yield call(onLoggingReports, data);
    yield call(responseHandler, "Login", response, loginReportsSuccess, loginReportsFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(loginReportsFail(error));
    showToast("error", "Login", error);
  }
}

function* onSuperAdminLogin({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onLoginSuperAdmin, data);
    yield call(responseHandler, "Login", response, superAdminLoginSuccess, superAdminLoginFail, onSuccess, onError);
  } catch (error) {
    onError();
    showToast("error", "Super Admin Login", error);
    yield put(superAdminLoginFail(error));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");
    localStorage.removeItem("superAdmin");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("uid");
    localStorage.removeItem("fastLogin");
    window.location.href = "/login";
  } catch (error) {
    yield put(apiError(error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    history.push("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* NormalLogin({ payload: { data, onError, onSuccess, header } }) {
  try {
    const response = yield call(onAdminLogin, data, header);
    yield call(responseHandler, "Login", response, postloginSuccess, postloginFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(postloginFail(error));
    showToast("error", "Login", error);
  }
}
function* ResendingOtp({ payload: data }) {
  try {
    const response = yield call(onResendOtp, data);
    if (response.status) {
      yield put(resendOtpSuccess(response));
      showToast("success", "Resend OTP", response.message);
    } else {
      yield put(resendOtpFail(response));
      showToast("warning", "Resend OTP", response.message);
    }
  } catch (error) {
    yield put(resendOtpFail(error));
    showToast("error", "Resend OTP", error);
  }
}
function* AdminResendingOtp({ payload: data }) {
  try {
    const response = yield call(onAdminResendOtp, data);
    if (response.status) {
      yield put(adminResendOtpSuccess(response));
      showToast("success", "Resend OTP", response.message);
    } else {
      yield put(adminResendOtpFail(response));
      showToast("warning", "Resend OTP", response.message);
    }
  } catch (error) {
    yield put(adminResendOtpFail(error));
    showToast("warning", "Resend OTP", error);
  }
}

function* EmpNormalLogin({ payload: { data, onSuccess, onError, header } }) {
  try {
    const response = yield call(PostEmpLoginUser, data, header);
    yield call(responseHandler, "Employee Login", response, empLoginSuccess, empLoginFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(empLoginFail(error));
    showToast("error", "Employee Login", error);
  }
}

function* onEmpVerifyOtp({ payload: { data, history } }) {
  try {
    const response = yield call(onEmpOtpVerify, data);
    if (response.status) {
      if (localStorage.getItem("loginData")) localStorage.removeItem("loginData");
      const data = {
        uid: response.data.user_data.staff_id,
        username: response.data.user_data.name,
        role: "staff",
        email: response.data.user_data.email_addresses,
        pro_pic: response.data.user_data.profile_picture,
        staff_uid: response.data.user_data.staff_token,
        time_zone: response.data.user_data.time_zone,
      };
      localStorage.setItem("uid", JSON.stringify(data.staff_uid));
      localStorage.setItem("authUser", JSON.stringify(data));
      localStorage.setItem("timezone", JSON.stringify(response.data.user_data?.time_zone));
      localStorage.setItem("pro_pic", JSON.stringify(response.data.user_data?.profile_picture));
      showToast("success", "Authentication", response.message);
      if (response.data.user_data?.emp_account_status) {
        history.push("/staff-view");
      } else {
        history.push("/employee-profile");
      }
    } else if (response.status === 203) {
      showToast("warning", "Authentication", response.message);
    } else {
      showToast("error", "Authentication", response.message);
    }
  } catch (error) {
    yield put(postloginFail(error));
    showToast("error", "Authentication", error);
  }
}

function* authSaga() {
  yield takeEvery(SUPER_ADMIN_LOGIN, onSuperAdminLogin);
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(REPORT_LOGIN, onReportLogin);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
  yield takeEvery(VERIFY_OTP, onVerifyOtp);
  yield takeEvery(POST_LOGIN, NormalLogin);
  yield takeEvery(EMPLOYEE_LOGIN, EmpNormalLogin);
  yield takeEvery(EMP_VERIFY_OTP, onEmpVerifyOtp);
  yield takeEvery(RESEND_OTP, ResendingOtp);
  yield takeEvery(ADMIN_RESEND_OTP, AdminResendingOtp);
}

export default authSaga;
